// extracted by mini-css-extract-plugin
export default {"card_container":"style_card_container__7eeYK","image_container":"style_image_container__dBR5K","card_content":"style_card_content__786xN","click_bait":"style_click_bait__i13l4"};